export default "__VITE_ASSET__whBej7yr__"